import { useCustomer } from '@order/Customer';
import { useFeatureFlag } from '@order/LaunchDarkly';

/**
 * Past orders and/or interactions might be done with now-deleted addresses.
 * These addresses will no longer be valid and should not be used.
 */
export const useIsCustomerAddress = (addressId?: string) => {
  const isFeatureEnabled = useFeatureFlag(
    'XP-2953-short-exclude-deleted-addresses-enabled',
  );

  const { customer } = useCustomer();
  const addresses = customer?.addresses ?? [];

  // Previous behavior was that all addresses were valid.
  if (!isFeatureEnabled) return true;

  return addresses.some((address) => address.id === addressId);
};
